import { SALES_ORDER_COLUMN_LAYOUT } from '../DataTable/columnWidths';
import { Bar } from '../Skeleton/primitives';

export function OrderSkeletonCell({ columnId }: { columnId: string }) {
  if (SALES_ORDER_COLUMN_LAYOUT.find((column) => column.id === columnId)?.blank) return null;

  switch (columnId) {
    case 'order_number':
      return <Bar className="h-[21px] w-[70px] max-w-full" />;
    case 'events':
      return (
        <div className="flex items-center gap-2 min-w-0">
          <Bar className="h-[21px] w-[43px] rounded-xs shrink-0" />
          <Bar className="h-[21px] w-[132px] max-w-full" />
        </div>
      );
    case 'contact':
      return (
        <div className="flex flex-col gap-1.5">
          <Bar className="h-[21px] w-[180px] max-w-full" />
          <Bar className="h-[15px] w-[240px] max-w-full" />
        </div>
      );
    case 'salesperson':
      return (
        <div className="flex items-center gap-3 min-w-0">
          <Bar className="size-12 rounded-full shrink-0" />
          <Bar className="h-[21px] w-20 max-w-full" />
        </div>
      );
    case 'total_amount':
      return <Bar className="h-[21px] w-20 max-w-full" />;
    case 'order_status':
    case 'xero_invoice_id':
      return <Bar className="h-[21px] w-status-badge rounded-xs max-w-full" />;
    default:
      return <Bar className="h-4 w-3/4" />;
  }
}
